import { ObservableHistory } from 'mobx-observable-history';
import { Location, LocationDescriptor } from 'history';

/**
 * Thin router facade over ObservableHistory (mobx-observable-history).
 * Replaces mobx-react-router, whose peer range stops at mobx 5.
 * location reads stay reactive because ObservableHistory.location is observable.
 */
export default class RouterStore {
  history!: ObservableHistory;

  constructor(history?: ObservableHistory) {
    if (history) {
      this.history = history;
    }
  }

  get location(): Location {
    return this.history.location;
  }

  push(location: LocationDescriptor<{}>, state?: {}): void {
    this.history.push(location as any, state as any);
  }

  replace(location: LocationDescriptor<{}>, state?: {}): void {
    this.history.replace(location as any, state as any);
  }

  go(n: number): void {
    this.history.go(n);
  }

  goBack(): void {
    this.history.goBack();
  }

  goForward(): void {
    this.history.goForward();
  }
}
